export default {
  name: {
    type: 'translatable-text',
    value: null,
    meta: {
      default_lang: 'en',
    },
    translations: [{ language: 'vi', value: '' }],
  },
  description: {
    type: 'translatable-text',
    value: null,
    meta: {
      default_lang: 'en',
    },
    translations: [{ language: 'vi', value: '' }],
  },
  ordinal_of_week: 1,
  rewards: [
    {
      type: 'GEM',
      amount: 0
    }
  ]
}
